<template>
  <div>
    <div class="row mx-md-n2">
      <div class="col-sm-4 px-md-2">
        <b-form-group
          label="First Name"
          :invalid-feedback="errors.first_name ? errors.first_name[0] : ''"
          :state="errors.first_name ? false : null"
        >
          <b-form-input
            name="first_name" type="text"
            required trim
            v-model="user.first_name"
            :state="errors.first_name ? false : null"
            :disabled="loading"
          />
        </b-form-group>
      </div>

      <div class="col-sm-4 px-md-2">
        <b-form-group
          label="Last Name"
          :invalid-feedback="errors.last_name ? errors.last_name[0] : ''"
          :state="errors.last_name ? false : null"
        >
          <b-form-input
            name="last_name" type="text"
            required trim
            v-model="user.last_name"
            :state="errors.last_name ? false : null"
            :disabled="loading"
          />
        </b-form-group>
      </div>
    </div>

    <div class="row mx-md-n2">
      <div class="col-sm-6 px-md-2">
        <b-form-group
          label="Your Bio"
          :invalid-feedback="errors.bio ? errors.bio[0] : ''"
          :state="errors.bio ? false : null"
        >
          <b-form-input
            name="bio" type="text"
            trim
            v-model="user.bio"
            :state="errors.bio ? false : null"
            :disabled="loading"
          />
        </b-form-group>
      </div>

      <div class="col-sm-6 px-md-2">
        <b-form-group
          label="Photo"
          :invalid-feedback="errors.avatar ? errors.avatar[0] : ''"
          :state="errors.avatar ? false : null"
        >
          <b-form-file
            name="avatar" type="file"
            accept="image/png,image/jpeg,image/jpg,image/gif"
            placeholder="Choose a file..." 
            @change="user.avatar = $event.target.files[0]"
            :state="errors.avatar ? false : null"
            :disabled="loading"
          />
        </b-form-group>
      </div>
    </div>

    <div class="row mx-md-n2">
      <div class="col-sm-4 px-md-2">
        <b-form-group
          label="Email Address"
          :invalid-feedback="errors.email ? errors.email[0] : ''"
          :state="errors.email ? false : null"
        >
          <b-form-input
            name="email" type="email"
            required trim autocomplete="username"
            v-model="user.email"
            :state="errors.email ? false : null"
            :disabled="loading"
          />
        </b-form-group>
      </div>

      <div class="col-sm-4 px-md-2" v-if="passwords">
        <b-form-group
          label="Password"
          :invalid-feedback="errors.password ? errors.password[0] : ''"
          :state="errors.password ? false : null"
        >
          <b-form-input
            name="password" type="password"
            required trim autocomplete="new-password"
            v-model="user.password"
            :state="errors.password ? false : null"
            :disabled="loading"
          />
        </b-form-group>
      </div>

      <div class="col-sm-4 px-md-2" v-if="passwords">
        <b-form-group
          label="Confirm Password"
          :state="errors.password ? false : null"
        >
          <b-form-input
            name="password_confimation" type="password"
            required trim autocomplete="new-password"
            v-model="user.password_confirmation"
            :state="errors.password ? false : null"
            :disabled="loading"
          />
        </b-form-group>
      </div>
    </div>

    <div class="row">
      <div class="col-12">
        <b-form-group label="User Type">
          <b-form-radio-group
            name="user_type" required
            v-model="user.user_type"
          >
            <b-form-radio value="advisor">I'm an Advisor</b-form-radio>
            <b-form-radio value="entrepreneur">I'm an Entrepreneur</b-form-radio>
          </b-form-radio-group>
        </b-form-group>
      </div>
    </div>

    <div class="row">
      <div class="col-6">
        <b-form-group label="In-Person Location">
          <b-form-textarea
            v-model="user.in_person_location"
            placeholder="Default in-person location"
            rows="2" max-rows="4"
            class="h-25"
          />
        </b-form-group>
      </div>

      <div class="col-6">
        <b-form-group label="Remote Location">
          <b-form-textarea
            v-model="user.remote_location"
            placeholder="Default remote location"
            rows="2" max-rows="4"
            class="h-25"
          />
        </b-form-group>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'UserInfoForm',
  props: {
    data: Object,
    errors: Object,
    loading: Boolean,
    passwords: Boolean
  },
  data () {
    return {
      user: {}
    }
  },
  mounted () {
    this.user = Object.assign({}, this.data)
  }
}
</script>
